export default __webpack_public_path__ + "static/media/sliver-logo.cee0242f.png";